import { useSnapCarousel } from "react-snap-carousel";

/* const StarIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.634 6.68111C14.5921 6.55769 14.5149 6.44924 14.4121 6.36915C14.3093 6.28906 14.1852 6.24084 14.0553 6.23044L10.2546 5.92844L8.60995 2.28778C8.55758 2.17052 8.47238 2.07092 8.36465 2.00102C8.25692 1.93111 8.13126 1.89387 8.00284 1.8938C7.87441 1.89373 7.74871 1.93083 7.6409 2.00062C7.5331 2.07041 7.44779 2.16991 7.39529 2.28711L5.75062 5.92844L1.94996 6.23044C1.82226 6.24056 1.70018 6.28725 1.59832 6.36493C1.49647 6.44261 1.41915 6.54799 1.37562 6.66846C1.33208 6.78894 1.32418 6.9194 1.35285 7.04425C1.38152 7.16909 1.44556 7.28304 1.53729 7.37244L4.34595 10.1104L3.35262 14.4118C3.32246 14.542 3.33213 14.6782 3.38037 14.8029C3.42861 14.9275 3.5132 15.0348 3.62316 15.1107C3.73311 15.1867 3.86337 15.2279 3.99701 15.2289C4.13065 15.2299 4.26152 15.1907 4.37262 15.1164L8.00262 12.6964L11.6326 15.1164C11.7462 15.1918 11.8801 15.2307 12.0164 15.2277C12.1527 15.2247 12.2847 15.18 12.3949 15.0997C12.505 15.0194 12.5879 14.9073 12.6325 14.7785C12.677 14.6497 12.681 14.5103 12.644 14.3791L11.4246 10.1124L14.4486 7.39111C14.6466 7.21244 14.7193 6.93378 14.634 6.68111Z"
        fill="#FFD05B"
      />
    </svg>
  );
}; */

export default function Testimonials({ title, description, testimonials }) {
  const { scrollRef, pages, activePageIndex, prev, next } = useSnapCarousel();
  return (
    <section className="relative overflow-hidden py-10 lg:py-0">
      <div className="w-full flex-1 flex xl:gap-1 items-center flex-col xl:flex-row xl:ml-[calc((100vw-1280px)/2)]">
        <div className="w-full px-6 text-center xl:text-left xl:mb-11 xl:px-0 xl:max-w-md">
          <h3 className="text-black-100 font-anton mb-3.5 text-4xl xl:text-5xl">
            {title}
          </h3>
          <p className="block text-sm font-medium text-gray-200">
            {description}
          </p>
          <div className="gap-4 mt-6 hidden xl:flex">
            <button
              onClick={() => prev()}
              disabled={activePageIndex === 0}
              className="group flex items-center justify-center bg-white rounded-full p-5 lg:size-20 transition-colors hover:bg-primary-200"
            >
              <svg
                width="36"
                height="37"
                viewBox="0 0 36 37"
                xmlns="http://www.w3.org/2000/svg"
                className="transition-colors fill-primary-200 group-hover:fill-white"
              >
                <path d="M19.9415 26.9189L11.381 18.3584L19.9415 9.79785L22.0625 11.9189L15.623 18.3584L22.0625 24.7978L19.9415 26.9189Z" />
              </svg>
            </button>
            <button
              onClick={() => next()}
              disabled={activePageIndex === pages.length - 1}
              className="group flex items-center justify-center bg-white rounded-full p-5 lg:size-20 transition-colors hover:bg-primary-200"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                xmlns="http://www.w3.org/2000/svg"
                className="transition-colors fill-primary-200 group-hover:fill-white"
              >
                <path d="M16.0585 26.9189L24.619 18.3584L16.0585 9.79785L13.9375 11.9189L20.377 18.3584L13.9375 24.7978L16.0585 26.9189Z" />
              </svg>
            </button>
          </div>
        </div>
        <div
          className="flex-1 h-full flex gap-2.5 -mx-6 px-6 py-10 xl:gap-10 overflow-x-auto remove-scroll snap-x snap-start max-w-full xl:mx-0 xl:px-4 xl:py-24"
          ref={scrollRef}
        >
           {testimonials.map((item, index) => {
            return (
              <div
                key={`testimonial-${index}`}
                className="flex flex-col gap-6 min-w-52 max-w-52 xl:min-w-80 xl:max-w-80 w-full p-6 h-auto bg-white rounded-lg shadow-xl "
              >
                <svg
                  width="42"
                  height="32"
                  viewBox="0 0 42 32"
                  fill="#6366f1"
                  xmlns="http://www.w3.org/2000/svg"
                  class=""
                >
                  <path d="M13.6406 0.415096C14.6782 -0.264151 15.6242 -0.109778 16.4786 0.878217C17.333 1.80446 17.333 2.69983 16.4786 3.56432C14.5866 5.47856 13.2744 6.96055 12.542 8.01029C11.8097 9.06003 11.3824 10.2024 11.2604 11.4374C11.1383 12.7959 11.535 13.4751 12.4505 13.4751C14.2815 13.4751 15.8378 14.3087 17.1194 15.976C18.4011 17.5815 19.0419 19.6501 19.0419 22.1818C19.0419 25.1458 18.1875 27.5232 16.4786 29.3139C14.8307 31.1046 12.6031 32 9.79561 32C7.11021 32 4.791 31.012 2.83798 29.036C0.945993 26.9983 0 24.2504 0 20.7925C0 12.765 4.54687 5.97256 13.6406 0.415096ZM36.3445 0.415096C37.382 -0.264151 38.328 -0.109778 39.1824 0.878217C40.0369 1.80446 40.0369 2.69983 39.1824 3.56432C37.2905 5.47856 35.9783 6.96055 35.2459 8.01029C34.5135 9.06003 34.0863 10.2024 33.9642 11.4374C33.8422 12.7959 34.2389 13.4751 35.1543 13.4751C36.9853 13.4751 38.5416 14.3087 39.8233 15.976C41.1049 17.5815 41.7458 19.6501 41.7458 22.1818C41.7458 25.1458 40.8913 27.5232 39.1824 29.3139C37.5346 31.1046 35.3069 32 32.4995 32C29.8141 32 27.4948 31.012 25.5418 29.036C23.6498 26.9983 22.7038 24.2504 22.7038 20.7925C22.7038 12.765 27.2507 5.97256 36.3445 0.415096Z"></path>
                </svg>
                {/* <div className="w-full">
                  <img
                    src={item?.image}
                    alt={item.title}
                    width={100}
                    height={100}
                    className="rounded-full mx-auto size-14 object-cover object-center lg:size-24"
                  />
                </div> */}
                <p className="text-sm font-medium text-gray-300">
                  {item.description}
                </p>
                {/* <div className="w-full h-px bg-[#A79FB3]" /> */}
                <div className="flex items-center justify-between mt-auto">
                  <div>
                    <h5 className="ttext-sm font-bold text-gray-300">
                      {item.name}
                    </h5>
                    <span className="block text-xs font-medium text-gray-200">
                      {item.idName}
                    </span>
                  </div>
                  {/* <div className="flex-shrink-0 flex items-center gap-1">
                    <StarIcon />
                    <StarIcon />
                    <StarIcon />
                    <StarIcon />
                    <StarIcon />
                  </div> */}
                </div>
              </div>
            );
          })}
          
        </div>
        <div className="gap-4 flex xl:hidden">
          <button
            onClick={() => prev()}
            disabled={activePageIndex === 0}
            className="group flex items-center justify-center bg-white rounded-full p-4 lg:p-5 lg:size-20 transition-colors hover:bg-primary-200"
          >
            <svg
              width="36"
              height="37"
              viewBox="0 0 36 37"
              xmlns="http://www.w3.org/2000/svg"
              className="transition-colors fill-primary-200 group-hover:fill-white"
            >
              <path d="M19.9415 26.9189L11.381 18.3584L19.9415 9.79785L22.0625 11.9189L15.623 18.3584L22.0625 24.7978L19.9415 26.9189Z" />
            </svg>
          </button>
          <button
            onClick={() => next()}
            disabled={activePageIndex === pages.length - 1}
            className="group flex items-center justify-center bg-white rounded-full p-4 lg:p-5 lg:size-20 transition-colors hover:bg-primary-200"
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              xmlns="http://www.w3.org/2000/svg"
              className="transition-colors fill-primary-200 group-hover:fill-white"
            >
              <path d="M16.0585 26.9189L24.619 18.3584L16.0585 9.79785L13.9375 11.9189L20.377 18.3584L13.9375 24.7978L16.0585 26.9189Z" />
            </svg>
          </button>
        </div>
        <div className="overflow-hidden max-w-2xl w-full h-full bg-primary-50 rounded-l-lg absolute inset-y-0 right-0 -z-10 hidden xl:block" />
      </div>
    </section>
  );
}
